(()=>{
  if(window.__bpConceptCards)return;window.__bpConceptCards=true;
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-concept-card-preset]');if(!button)return;
    const card=button.closest('[data-concept-card]'),image=card?.querySelector('[data-concept-card-image]');if(!card||!image)return;
    event.preventDefault();
    // Real rendered images only. Never hue-rotate the entire sled or its hardware.
    image.removeAttribute('srcset');image.src=button.dataset.image;
    card.querySelectorAll('[data-concept-card-link]').forEach(link=>{link.href=button.dataset.link;});
    card.querySelectorAll('[data-concept-card-preset]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
  });
})();

